import { BookMockup } from "../BookMockup";
import { ChapterHeading } from "../ChapterHeading";
import { Reveal } from "../motion/Reveal";

const STATS = [
  { value: "100", label: "Situations" },
  { value: "300", label: "Message versions" },
  { value: "100", label: "Email subjects" },
  { value: "100", label: "Conversation openers" },
];

export function ProductContent() {
  return (
    <section id="product" className="py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <ChapterHeading
          index="07"
          eyebrow="The product"
          title={
            <>
              A working tool, <em className="font-normal">not a read.</em>
            </>
          }
        />
        <div className="mt-14 grid grid-cols-1 items-center gap-14 lg:grid-cols-12">
          <Reveal className="lg:col-span-4">
            <div className="relative mx-auto w-52 sm:w-60">
              <div
                aria-hidden="true"
                className="absolute -inset-5 -z-10 rounded-2xl border border-line bg-surface/60"
              />
              <BookMockup />
              <div
                aria-hidden="true"
                className="mx-auto mt-5 h-4 w-3/4 rounded-[50%] bg-ink/15 blur-md"
              />
            </div>
          </Reveal>
          <div className="lg:col-span-8">
            <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-line bg-line">
              {STATS.map((s, i) => (
                <Reveal key={s.label} delay={i * 0.06} className="h-full">
                  <div className="flex h-full flex-col justify-between gap-8 bg-paper p-7">
                    <span className="font-display text-5xl font-light tracking-tight text-ink">
                      {s.value}
                    </span>
                    <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-faint">
                      {s.label}
                    </span>
                  </div>
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.2}>
              <p className="mt-6 text-sm leading-relaxed text-smoke">
                Delivered as the{" "}
                <span className="font-medium text-ink">117-page Manager Edition</span>{" "}
                — a professionally designed PDF, laid out for scanning in the
                moment you need it.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
